import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
    DxTextBoxModule,
    DxFormModule,
    DxValidatorModule,
    DxSelectBoxComponent,
} from 'devextreme-angular';
import { getSizeQualifier } from 'src/app/services/screen.service';
import { CarrierDto, CarrierStatus } from '@services';
import EnumUtils from '../../../../shared/enum-utils';

@Component({
    selector: 'carrier-form',
    imports: [
        DxTextBoxModule,
        DxFormModule,
        DxValidatorModule,
        CommonModule,
        DxSelectBoxComponent
    ],
    templateUrl: './carrier-form.component.html',
})
export class CarrierFormComponent {
    @Input() isReadOnly: boolean = false;
    @Input() data: CarrierDto = {
        status: CarrierStatus.Active,
    } as CarrierDto;

    carrierStatusOptions = EnumUtils.getEnumOptions(CarrierStatus);

    getSizeQualifier = getSizeQualifier;

    getData = () => ({ ...this.data }) as CarrierDto;
}
